export default __webpack_public_path__ + "static/media/screen5.facc7b48.png";